export default {
  register: { method: "post", url: "services/create" },
};
